import $ from 'jquery'
/**
 * Load theme
 * This is a hack...
 * If CSS are loaded dynamicly after de initial map render we to need trigger a map.setSize() to get correct positioning of interactions and tiles (OL3 bug?).
 * If CSS are loaded by changing the <style> href path we have no way to now when the new CSS is fully loaded.
 * By loading the CSS file with AJAX we can triggger a map.setSize() after the CSS is injected into the page.
 * @ignore
 */
export default function(theme, map) {
  const $olgaContainer = $('#olga-container')
  const $olViewport = $('#map .ol-viewport:first')
  $olgaContainer.hide() // Hide UI while loading theme css
  if (window.olga && window.olga.standalone) {
    let themeUrl =
      !theme || theme === 'default' ? undefined : `css/${theme}/style.css`
    if (themeUrl) {
      $.get(themeUrl)
        .done(css => {
          $('#olga-theme').remove()
          $('<style></style>')
            .text(css)
            .appendTo('head')
          $olgaContainer.show()
          map.setSize([$olViewport.width(), $olViewport.height()])
        })
        .fail(err =>
          alert(
            `Misslyckades att ladda temafilen för "${theme}".\n\n${err.responseText}`
          )
        )
    } else {
      $olgaContainer.show()
      map.setSize([$olViewport.width(), $olViewport.height()])
    }
  } else {
    $olgaContainer.show()
    map.setSize([$olViewport.width(), $olViewport.height()])
  }
}
